import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-org-breadcrumb',
  templateUrl: './my-org-breadcrumb.component.html',
  styleUrls: ['./my-org-breadcrumb.component.scss']
})
export class MyOrgBreadcrumbComponent implements OnInit {
  public title: any;

    constructor(
        private router: Router,
    ) {}

    @Input() additionalMsg: string;
    @Input() additionalHeader: string;

  ngOnInit() {
    let url = this.router.url.replace('/', '',);
    let search = '-';
    let replaceWith = ' ';
    this.title = url.split(search).join(replaceWith);
    // find my forms page
    let splitTitle = this.title.split('/');
    let firstPath = splitTitle[0];
    if (firstPath === 'my forms') {
      this.title = 'My Forms';
    }
    if (this.title === 'my files') {
      this.title = 'My Completed Documents';
    } else if (this.title === 'shared doc') {
      this.title = 'Documents Shared with Me';
    } else if (this.title === 'dashboard') {
      this.title = 'Organization Dashboard';
    } else if (this.title === 'charities') {
      this.title = 'Organization Information';
    }
  }

    onHome(){
        this.router.navigateByUrl('/');
    }
    onMyorg(){
      this.router.navigateByUrl('/charities')
    }

}
